<template>
  <div ref="chartEl" class="ja-apex-chart" />
</template>

<script>
const getChartConstructor = () => {
  if (typeof window !== "undefined" && typeof window.ApexCharts === "function") {
    return window.ApexCharts;
  }
  return null;
};

export default {
  name: "JaApexChart",
  props: {
    type: { type: String, default: "line" },
    series: { type: Array, required: true },
    options: { type: Object, default: () => ({}) },
    height: { type: [String, Number], default: 350 },
    width: { type: [String, Number], default: "100%" },
  },
  data() {
    return { chart: null };
  },
  watch: {
    series: {
      deep: true,
      handler(val) {
        if (this.chart) {
          this.chart.updateSeries(val);
        } else {
          this.renderChart();
        }
      },
    },
    options: {
      deep: true,
      handler() {
        if (this.chart) {
          this.chart.updateOptions(this.buildConfig(), false, true);
        } else {
          this.renderChart();
        }
      },
    },
    type() {
      this.refreshChart();
    },
    height() {
      this.refreshChart();
    },
    width() {
      this.refreshChart();
    },
  },
  mounted() {
    this.renderChart();
  },
  beforeDestroy() {
    this.destroyChart();
  },
  methods: {
    buildConfig() {
      const baseOptions = this.options || {};
      const chartOptions = baseOptions.chart || {};

      return {
        ...baseOptions,
        chart: {
          ...chartOptions,
          type: this.type || chartOptions.type || "line",
          height: this.height,
          width: this.width,
          fontFamily: chartOptions.fontFamily || "inherit",
        },
        series: this.series,
      };
    },
    renderChart() {
      const el = this.$refs.chartEl;
      const ChartConstructor = getChartConstructor();
      if (!el || typeof ChartConstructor !== "function") return;

      this.destroyChart();
      this.chart = new ChartConstructor(el, this.buildConfig());
      this.chart.render();
    },
    refreshChart() {
      this.$nextTick(() => this.renderChart());
    },
    destroyChart() {
      if (this.chart) {
        this.chart.destroy();
        this.chart = null;
      }
    },
  },
};
</script>

<style scoped>
.ja-apex-chart {
  width: 100%;
}
</style>
